var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 48,
    viewBox: "0 0 70 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 48,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3525 10C51.8897 10 57.9998 16.181 58 23.8057C58 31.4305 51.8898 37.6123 44.3525 37.6123C40.9742 37.6123 37.8832 36.3694 35.5 34.3125C33.1168 36.3694 30.0258 37.6123 26.6475 37.6123C19.1102 37.6123 13 31.4305 13 23.8057C13.0002 16.181 19.1103 10 26.6475 10C30.0254 10 33.1169 11.2413 35.5 13.2979C37.8831 11.2413 40.9746 10 44.3525 10Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3525 10C51.8897 10 57.9998 16.181 58 23.8057C58 31.4305 51.8898 37.6123 44.3525 37.6123C40.9742 37.6123 37.8832 36.3694 35.5 34.3125C38.434 31.7802 40.2949 28.013 40.2949 23.8057C40.2948 19.5981 38.4344 15.8301 35.5 13.2979C37.8831 11.2413 40.9746 10 44.3525 10Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 13.2981C38.4344 15.8304 40.2949 19.5983 40.2949 23.8059C40.2949 28.0133 38.4341 31.7805 35.5 34.3127C32.566 31.7805 30.7051 28.0132 30.7051 23.8059C30.7051 19.5983 32.5657 15.8304 35.5 13.2981Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.df7172cc97acb2cc56f3bf3d13eff1ec.svg";
export { ForwardRef as ReactComponent };